// Change Password states
import { changePassword, changePasswordConfig } from './changePassword'

export default function changePasswordRoutes($stateProvider) {
  'ngInject'
  $stateProvider.state(changePassword, changePasswordConfig)
}
